import { GetterTree } from 'vuex'
import { RootState } from '../types'
import { ProfileState } from './types'

export const getters: GetterTree<ProfileState, RootState> = {}
